import { createFileRoute, Link } from "@tanstack/react-router";
import { SiteNav } from "@/components/site/SiteNav";
import { Footer } from "@/components/site/Sections";
import { BookOpen, Sparkles, ArrowRight, ChevronRight } from "lucide-react";

export const Route = createFileRoute("/blogs")({
  head: () => ({
    meta: [
      {
        title: "Blogs & Insights — KMWAdvertising LLP",
      },
      {
        name: "description",
        content:
          "Latest advertising trends, performance marketing insights, media buying strategies, and brand design analysis from KMWAdvertising LLP.",
      },
    ],
  }),
  component: BlogsPage,
});

export function BlogsPage() {
  const blogPosts = [
    {
      title: "The Evolution of 360-Degree Advertising in 2026",
      category: "Media Strategy",
      date: "August 2026",
      desc: "How traditional television and outdoor media seamlessly integrate with programmatic performance marketing to drive maximum ROAS.",
    },
    {
      title: "Why Brand Identity Matters More Than Ever for Scale-ups",
      category: "Branding",
      date: "July 2026",
      desc: "In an era of copycat products, your visual identity and brand story remain your strongest competitive moat.",
    },
    {
      title: "Maximizing Conversion Rates with AI-Powered Ad Creatives",
      category: "Digital Performance",
      date: "June 2026",
      desc: "Leveraging generative AI scriptwriting and dynamic video personalization to scale ad campaigns across Meta, TikTok, and YouTube.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#07070d] text-slate-100 selection:bg-purple-500 selection:text-white font-sans relative overflow-x-hidden">
      <SiteNav />

      <section className="relative pt-32 pb-20 md:pt-40 md:pb-28">
        <div className="container-x relative z-10">
          <div className="flex items-center gap-2 text-xs font-mono text-slate-400 mb-6">
            <Link to="/" className="hover:text-white transition">
              Home
            </Link>
            <ChevronRight className="h-3 w-3 text-slate-600" />
            <span className="text-purple-400">Blogs</span>
          </div>

          <div className="max-w-4xl mb-16">
            <div className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-purple-500/10 border border-purple-500/20 text-purple-300 text-xs font-mono font-bold uppercase tracking-wider mb-6">
              <BookOpen className="h-3.5 w-3.5" />
              Industry Insights & Articles
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white tracking-tight leading-[1.12] mb-6">
              Blogs & Insights
              <span className="block bg-gradient-to-r from-purple-400 via-pink-300 to-amber-300 bg-clip-text text-transparent mt-1">
                Perspectives on Media, Branding & Growth
              </span>
            </h1>

            <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
              Explore strategic insights, industry reports, and actionable advertising intelligence compiled by KMWAdvertising LLP experts.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {blogPosts.map((post) => (
              <div
                key={post.title}
                className="p-6 rounded-3xl bg-white/[0.02] border border-white/10 hover:border-purple-500/40 transition space-y-4 flex flex-col justify-between"
              >
                <div className="space-y-3">
                  <div className="flex items-center justify-between text-xs font-mono">
                    <span className="text-purple-400 bg-purple-500/10 px-2.5 py-1 rounded-full border border-purple-500/20 font-bold">
                      {post.category}
                    </span>
                    <span className="text-slate-400">{post.date}</span>
                  </div>

                  <h2 className="text-xl font-bold text-white hover:text-purple-300 transition">
                    {post.title}
                  </h2>

                  <p className="text-xs text-slate-300 leading-relaxed">{post.desc}</p>
                </div>

                <Link
                  to="/contact-us"
                  className="inline-flex items-center gap-2 text-xs font-bold text-purple-300 hover:text-white transition pt-4"
                >
                  <span>Read Article</span>
                  <ArrowRight className="h-3.5 w-3.5" />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
